import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import type { Participant } from "@/react/types/Live/Participant";
import { usePunditUserContext } from "@circle-react/contexts";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { publicLiveStreams } from "@circle-react/helpers/urlHelpers";

const REFETCH_INTERVAL = 30 * 1000; //30s

export const useParticipants = () => {
  const { roomSlug } = useParams<{ roomSlug: string }>();
  const {
    currentCommunity = {
      id: null,
    },
    isLoading: isCommunityLoading,
  } = usePunditUserContext();

  const {
    data: participants = [],
    isLoading,
    isError,
    refetch: refetchParticipants,
  } = useQuery(
    ["public-live-stream", "participants", roomSlug, currentCommunity?.id],
    () =>
      reactQueryGet<Participant[]>(
        publicLiveStreams.rooms.participants.index({
          slug: roomSlug,
          params: {
            community_id: currentCommunity?.id,
          },
        }),
      ),
    {
      enabled: !isCommunityLoading && Boolean(roomSlug),
      refetchInterval: REFETCH_INTERVAL,
    },
  );

  const participantsCount = (participants || []).length;
  const activeParticipants = participants.filter(
    participant => participant.status === "active",
  );
  const hosts = activeParticipants.filter(
    participant => participant.role === "host",
  );

  return {
    participants,
    hosts,
    activeParticipants,
    isLoading: isLoading,
    isError,
    refetchParticipants,
    totalCount: participantsCount,
    activeCount: activeParticipants.length,
  };
};
